import {COMMON_ACTION_TYPES, SHIFT_ACTION_TYPES} from "../../_constants";

const INITIAL_STATE = {
    shiftList: {
        isLoading: false,
        data: [],
    }
};

const shiftReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        // get Shift List
        case SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.REQUEST:
            return {
                ...state,
                shiftList: {
                    isLoading: true,
                    data: [],
                }
            };

        case SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.SUCCESS:
            return {
                ...state,
                shiftList: {
                    isLoading: false,
                    data: action.data
                }
            };

        case SHIFT_ACTION_TYPES.GET_SHIFT_LIST + COMMON_ACTION_TYPES.ERROR:
            return {
                ...state,
                shiftList: {
                    isLoading: false,
                    data: [],
                }
            };
        default:
            return state;
    }
}

export default shiftReducer;
